import Axios from 'axios'
import {
	IConfirmElectronicReceiptsHeadersValues,
	IConsultElectronicReceiptsParams,
	IGetElectronicReceiptsHeadersParams,
	IValidateElectronicReceiptParams
} from 'models/ElectronicReceipts'
const urlBase = 'p_ccfe_reenv'

export const getElectronicReceiptsHeadersApi = async (
	params: IGetElectronicReceiptsHeadersParams
) => {
	const response = await Axios.get(`${urlBase}/consulta`, { params })
	return response.data
}

export const confirmElectronicReceiptsHeadersApi = async (
	params: IConfirmElectronicReceiptsHeadersValues
) => {
	const response = await Axios.post(`${urlBase}/consulta/confirmar`, params)
	return response.data
}

export const validateElectronicReceiptsApi = async (
	params: IValidateElectronicReceiptParams
) => {
	const response = await Axios.post(`${urlBase}/enviar`, params)
	return response.data
}

export const consultElectronicReceiptsApi = async (
	params: IConsultElectronicReceiptsParams
) => {
	const response = await Axios.get(`${urlBase}/estado`, { params })
	return response.data
}

export const cancelElectronicReceiptsApi = async (
	params: IConsultElectronicReceiptsParams
) => {
	const response = await Axios.post(`${urlBase}/cancelar`, params)
	return response.data
}
